<template>
<div>
    <Breadcrumbs main="Admin" submain="Content" title="CoProduction Lab" />
    <!-- Container-fluid starts-->
    <div class="container-fluid">
        <div class="row">
            <div class="col-md-12">
                <div class="card">
                    <div class="card-header">
                        <button class="btn btn-primary" type="submit" v-b-modal.modal-prevent-closing style="display: flex; gap: 12px; align-items: center;">
                            <i class="fa fa-light fa-plus"></i>
                            <h7>Add New</h7>
                        </button>
                    </div>

                    <div class="card-body">
                        <b-row>
                            <b-col xl="6">
                                <b-input-group class="datatable-btn">
                                    <b-form-input v-model="filter" placeholder="Type to Search"></b-form-input>
                                    <b-input-group-append>
                                        <b-button :disabled="!filter" @click="filter = ''">Clear</b-button>
                                    </b-input-group-append>
                                </b-input-group>
                            </b-col>

                            <b-col xl="6">
                                <b-form-group label-cols="2" label="Per page" class="mb-0 datatable-select">
                                    <b-form-select v-model="perPage" :options="pageOptions"></b-form-select>
                                </b-form-group>
                            </b-col>
                        </b-row>

                        <div v-if="!loading && !error">
                            <div class="table-responsive datatable-vue">
                                <b-table show-empty stacked="md" :items="production_list" :fields="tablefields" :filter="filter" :current-page="currentPage" :per-page="perPage" @filtered="onFiltered">
                                    <template #cell(index)="data">
                                        {{ (currentPage - 1) * perPage + data.index + 1 }}
                                    </template>

                                    <template #cell(image)="row">
                                        <div v-if="row.item.image">
                                            <img style="width: 120px; border-radius: 4px;" :src="host + row.item.image" alt="">
                                        </div>
                                    </template>

                                    <template #cell(description)="row">
                                        <div v-if="row.item.description && row.item.description.length > 200" style="max-width: 400px;">
                                            <div>{{ row.item.description.slice(0, 200) }}...</div>
                                        </div>
                                        <div v-else style="max-width: 400px;">
                                            <div>{{ row.item.description }}</div>
                                        </div>
                                    </template>

                                    <template #cell(custom)="row">
                                        <div>
                                            <span v-if="row.item.custom === true" style="display: flex; flex-direction: column; align-items: start;">
                                                <b-badge pill variant="success" v-b-tooltip.hover title="Toggle custom" @click="toggleCustom(row.item.slug)">Yes</b-badge>
                                                <router-link :to="`/custom-ui/production/${row.item.slug}`">
                                                    <b-badge pill variant="primary">Details</b-badge>
                                                </router-link>
                                            </span>
                                            <span v-else>
                                                <router-link :to="`/custom-ui/production/${row.item.slug}`"> 
                                                    <b-badge pill variant="danger" v-b-tooltip.hover title="Toggle custom">No</b-badge>
                                                </router-link>
                                            </span>
                                        </div>
                                    </template>

                                    <template #cell(action)="data">
                                        <span style="display: flex; gap: 12px;">
                                            <div>
                                                <feather type="delete" size="22px" style="color: #ff595d; cursor: pointer;" v-b-tooltip.hover v-b-modal.modal-center @click="deleteCoProduction(data.item.id)" title="Delete"></feather>
                                            </div>

                                            <div @click="editCoProduction(data.item)">
                                                <feather type="edit" size="20px" style="color: #568ae3; cursor: pointer;" v-b-tooltip.hover title="Edit" v-b-modal.modal-prevent-closing-edit></feather>
                                            </div>
                                        </span>
                                    </template>
                                </b-table>
                            </div>
                        </div>

                        <div v-else>
                            <loader />
                        </div>

                        <b-col md="6" class="my-1 p-0">
                            <b-pagination v-model="currentPage" :total-rows="totalRows" :per-page="perPage" class="my-0"></b-pagination>
                        </b-col>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- Container-fluid Ends-->

    <!-- CoProduction Lab Create Modal -->
    <b-modal id="modal-prevent-closing" ref="modal" title="Add CoProduction Lab" size="xl" @show="resetModal" @hidden="resetModal" @ok="handleOk">
        <form ref="form" @submit.stop.prevent="handleSubmit()">
            <div class="row">
                <div class="col-sm-6">
                    <div class="form-group">
                        <label>Title</label>
                        <input class="form-control" type="text" v-model="production.title" placeholder="Enter title" />
                    </div>
                </div>
                <div class="col-sm-6">
                    <div class="form-group">
                        <label>Serial</label>
                        <input class="form-control" type="number" v-model="production.serial" placeholder="Enter serial" />
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-sm-6">
                    <div class="form-group">
                        <label>Redirection Link</label>
                        <input class="form-control" type="text" v-model="production.link" placeholder="Enter link" />
                    </div>
                </div>
                <div class="col-sm-6">
                    <div class="form-group">
                        <label>Youtube Video Link</label>
                        <input class="form-control" type="text" v-model="production.video_link" placeholder="Enter youtube video link" />
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-sm-12">
                    <div class="form-group">
                        <label>Description</label>
                        <b-form-textarea class="form-control" type="text" rows="5" v-model="production.description" placeholder="Enter description" />
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="form-group px-3">
                    <label>Image</label>
                    <div>
                        <img v-if="production.image" style="height: 80px; border-radius: 6px;" :src="production.image">
                        <input :class="production.image ? 'ml-2' : 'ml-0'" type="file" accept="image/*" @change="uploadMemberImage">
                    </div>
                </div>
            </div>
        </form>
    </b-modal>

    <!-- CoProduction Lab Edit Modal -->
    <b-modal id="modal-prevent-closing-edit" ref="modal" title="Edit CoProduction Lab" size="xl" @show="resetEditModal" @hidden="resetEditModal" @ok="handleEditOk">
        <form ref="form" @submit.stop.prevent="handleEditSubmit">
            <div class="row">
                <div class="col-sm-6">
                    <div class="form-group">
                        <label>Title</label>
                        <input class="form-control" type="text" v-model="edit_production.title" placeholder="Enter title" />
                    </div>
                </div>
                <div class="col-sm-6">
                    <div class="form-group">
                        <label>Serial</label>
                        <input class="form-control" type="number" v-model="edit_production.serial" placeholder="Enter serial" />
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-sm-6">
                    <div class="form-group">
                        <label>Redirection Link</label>
                        <input class="form-control" type="text" v-model="edit_production.link" placeholder="Enter link" />
                    </div>
                </div> 
                <div class="col-sm-6">
                    <div class="form-group">
                        <label>Youtube Video Link</label>
                        <input class="form-control" type="text" v-model="edit_production.video_link" placeholder="Enter youtube video link" />
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-sm-12">
                    <div class="form-group">
                        <label>Description</label>
                        <b-form-textarea class="form-control" type="text" rows="5" v-model="edit_production.description" placeholder="Enter description" />
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="form-group px-3">
                    <label>Image</label>
                    <div>
                        <img v-if="show_image" style="height: 80px; border-radius: 6px;" :src="show_image">
                        <input :class="show_image ? 'ml-2' : 'ml-0'" type="file" accept="image/*" @change="uploadMemberImage2">
                    </div>
                </div>
            </div>
        </form>
    </b-modal>

    <!-- CoProduction Lab Delete Modal -->
    <b-modal id="modal-center" centered hide-header @ok="handleDeleteOk">
        <div class="mt-4 mb-4" style="font-size: large;">Are you sure you want to delete this CoProduction Lab?</div>
    </b-modal>
</div>
</template>

<script>
import {
    mapState
} from 'vuex';
import {
    myHost
} from '../../../_helpers/host';
import loader from '../loader/loader.vue';
import Swal from 'sweetalert2/dist/sweetalert2.js';
import 'sweetalert2/src/sweetalert2.scss';

export default {
    components: {
        loader
    },

    data() {
        return {
            host: myHost.host,
            tablefields: [
                {
                    key: 'index',
                    label: '#'
                },
                {
                    key: 'title',
                    label: 'Title',
                    sortable: true
                },
                {
                    key: 'description',
                    label: 'Description',
                    sortable: true
                },
                {
                    key: 'image',
                    label: 'Image',
                    sortable: true
                },
                {
                    key: 'serial',
                    label: 'Serial',
                    sortable: true
                },
                {
                    key: 'custom',
                    label: 'Custom-UI',
                    sortable: true
                },
                {
                    key: 'action',
                    label: 'Action',
                    sortable: false
                }
            ],

            production: {
                title: '',
                description: '',
                link: '',
                video_link: '',
                serial: null,
                image: null
            },

            edit_production: {
                id: '',
                title: '',
                description: '',
                link: '',
                video_link: '',
                serial: null,
                image: null
            },

            delete_value: null,
            show_image: null,
            filter: null,
            totalRows: 1,
            currentPage: 1,
            perPage: 10,
            pageOptions: [10, 15, 20]
        };
    },

    computed: {
        ...mapState({
            production_list: state => state.production.production,
            loading: state => state.production.productionLoading,
            error: state => state.production.productionError
        }),

        sortOptions() {
            // Create an options list from our fields
            return this.tablefields
                .filter(f => f.sortable)
                .map(f => {
                    return {
                        text: f.label,
                        value: f.key
                    };
                });
        }
    },

    mounted() {
        this.$store.dispatch("production/fetchCoProduction").then(() => {
            this.items = this.production_list
            this.totalRows = this.production_list.length;
        });
    },

    methods: {
        uploadMemberImage(e) {
            const image = e.target.files[0];
            const reader = new FileReader();
            reader.readAsDataURL(image);
            reader.onload = e => {
                this.production.image = e.target.result
            };
        },

        uploadMemberImage2(e) {
            const image = e.target.files[0];
            const reader = new FileReader();
            reader.readAsDataURL(image);
            reader.onload = e => {
                this.edit_production.image = e.target.result
                this.show_image = e.target.result
            };
        },

        onFiltered(filteredItems) {
            this.totalRows = filteredItems.length;
            this.currentPage = 1;
        },

        resetModal() {
            this.production = {
                title: '',
                description: '',
                link: '',
                video_link: '',
                serial: null,
                image: null
            };
        },

        handleOk(bvModalEvent) {
            bvModalEvent.preventDefault()
            this.handleSubmit()
        },

        handleSubmit() {
            this.$store.dispatch("production/addCoProduction", {
                production: this.production
            }).then(response => {
                if (response.code == 200) {
                    Swal.fire({
                        title: "Success!",
                        text: response.response,
                        icon: "success"
                    });
                    this.resetModal();
                } else {
                    Swal.fire({
                        title: "Error!",
                        text: response.response,
                        icon: "error"
                    });
                }
            })

            this.$nextTick(() => {
                this.$bvModal.hide('modal-prevent-closing')
            })
        },

        editCoProduction(detail) {
            this.edit_production = {
                id: detail.id || null,
                title: detail.title || '',
                description: detail.description || null,
                link: detail.link || null,
                video_link: detail.video_link || null,
                serial: detail.serial || null
            };
            this.show_image = this.host + detail.image || null
        },

        resetEditModal() {
            this.edit_production = {
                id: '',
                title: '',
                description: '',
                link: '',
                video_link: '',
                serial: null,
                image: null
            };
        },

        handleEditOk(bvModalEvent) {
            bvModalEvent.preventDefault()
            this.handleEditSubmit()
        },

        handleEditSubmit() {
            this.$store.dispatch("production/updateCoProduction", {
                id: this.edit_production.id,
                production: this.edit_production
            }).then(response => {
                if (response.code == 200) {
                    Swal.fire({
                        title: "Success!",
                        text: response.response,
                        icon: "success"
                    });
                    this.resetEditModal();
                } else {
                    Swal.fire({
                        title: "Error!",
                        text: response.response,
                        icon: "error"
                    });
                }
            })

            this.$nextTick(() => {
                this.$bvModal.hide('modal-prevent-closing-edit')
            })
        },

        deleteCoProduction(id) {
            this.delete_value = id
        },

        handleDeleteOk() {
            this.$store.dispatch("production/deleteCoProduction", {
                delete: this.delete_value
            }).then(response => {
                if (response.code == 200) {
                    Swal.fire({
                        title: "Success!",
                        text: response.response,
                        icon: "success"
                    });
                    this.delete_value = null
                } else {
                    Swal.fire({
                        title: "Error!",
                        text: response.response,
                        icon: "error"
                    });
                }
            })
        }
    }
};
</script>
